import api from "@/services/api";

export interface UpdateFranchiseAssociateVouchersPayload {
  hasPremiumVoucher: boolean;
  premiumVoucherBalance: number;
}

class UpdateFranchiseAssociateVouchers {
  execute = async (id: string, payload: UpdateFranchiseAssociateVouchersPayload) => {
    const response = await api().patch(`/franchise-associates/${id}/vouchers`, payload);
    return response.data;
  };
}

export { UpdateFranchiseAssociateVouchers };
